import { Fragment, useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStyletron } from 'baseui';
import { Button, SHAPE, KIND } from 'baseui/button';

import { AppContext } from 'context';
import Logo from 'modules/shared/components/logo';
import Backdrop from '../../backdrop';
import SideDrawerItem from './side-drawer-item';
import contactImageURL from 'assets/icons/contact.svg';
import templateImageURL from 'assets/icons/template.svg';
import campaignImageURL from 'assets/icons/campaign.svg';

type Props = {
  open: boolean;
  closed: () => void;
};

const sideDrawerItems = [
  { id: 1, icon: contactImageURL, name: 'Contacts', route: '/contacts' },
  {
    id: 2,
    icon: templateImageURL,
    name: 'Templates',
    route: '/templates',
  },
  { id: 3, icon: campaignImageURL, name: 'Campaigns', route: '/campaigns' },
];

const SideDrawer = ({ open, closed }: Props) => {
  const {
    state: { token },
  } = useContext(AppContext);
  const [css] = useStyletron();
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const sideDrawerStyles = css({
    position: 'fixed',
    width: '280px',
    maxWidth: '70%',
    height: '100%',
    left: 0,
    top: 0,
    zIndex: 200,
    backgroundColor: 'white',
    padding: '32px 16px',
    boxSizing: 'border-box',
    transition: 'transform 0.3s ease-out',
    transform: open ? 'translateX(0)' : 'translateX(-100%)',
  });

  useEffect(() => {
    setIsAuthenticated(token && token !== '');
  }, [token]);

  const navigateToRoute = (route: string) => {
    navigate(route);
    closed();
  };

  return (
    <Fragment>
      <Backdrop show={open} clicked={closed} />
      <div className={sideDrawerStyles}>
        <div
          className={css({
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '50px',
          })}
        >
          <Logo width={100} height={100} clicked={() => {}} />
        </div>

        {!isAuthenticated ? (
          <>
            <div className={css({ width: '100%', padding: '10px 0' })}>
              <Button
                shape={SHAPE.default}
                className={css({ width: '100%' })}
                onClick={() => navigateToRoute('auth/signUp')}
              >
                Sign up
              </Button>
            </div>
            <div className={css({ width: '100%', padding: '10px 0' })}>
              <Button
                kind={KIND.secondary}
                shape={SHAPE.default}
                className={css({ width: '100%' })}
                onClick={() => navigateToRoute('auth/signIn')}
              >
                Sign in
              </Button>
            </div>
          </>
        ) : (
          <>
            {sideDrawerItems.map((item) => (
              <SideDrawerItem
                key={item.id}
                {...item}
                isActive={location.pathname?.indexOf(item.route) > -1}
                clicked={navigateToRoute}
              />
            ))}
          </>
        )}
      </div>
    </Fragment>
  );
};

export default SideDrawer;
